import { ItemStatus } from '@nohara-dxdev/mt-common';

export const getStatusLabel = (status: ItemStatus, t: any) => {
  switch (status.toLowerCase()) {
    case 'in-progress':
      return t('items.status.in-progress', 'In Progress');
    case 'specs-confirmed':
      return t('items.status.specs-confirmed', 'Specs Confirmed');
    case 'ordered':
      return t('items.status.ordered', 'Ordered');
    case 'installed':
      return t('items.status.installed', 'Installed');
    case 'tested':
      return t('items.status.tested', 'Tested');
    case 'locked':
      return t('items.status.locked', 'Locked');
    default:
      return status;
  }
};
